import { useCampaignsShow } from '@jobilla/nexus-sdk'

export type UseCampaignPollerArguments = {
	campaignId: string

	// this flag actually represents the entire campaign, even images, not just details
	detailsIsGenerating: boolean

	feedAdIsGenerating?: boolean
	storyAdIsGenerating?: boolean
	landingPageIsGenerating?: boolean
	formIsGenerating?: boolean
}

export function useCampaignPoller({
	campaignId,
	detailsIsGenerating = false,
	feedAdIsGenerating = false,
	storyAdIsGenerating = false,
	landingPageIsGenerating = false,
	formIsGenerating = false,
}: UseCampaignPollerArguments) {
	const isAnyGenerating = detailsIsGenerating
		|| feedAdIsGenerating
		|| storyAdIsGenerating
		|| landingPageIsGenerating
		|| formIsGenerating

	useCampaignsShow(campaignId, {
		// refetch every 3 seconds if any resource is generating, otherwise refetch every 15 seconds
		refetchInterval: isAnyGenerating ? 3000 : (15 * 1000),
		refetchIntervalInBackground: isAnyGenerating,
	})

	return {}
}
